import {
  createSlice,
  createEntityAdapter,
  createSelector,
} from '@reduxjs/toolkit';
import { normalize, schema } from 'normalizr';

const messageEntity = new schema.Entity('messages', {}, {
  processStrategy: (entity) => {
    entity.id = entity.messageUId || entity.messageId;
    return entity;
  },
});

const messageAdapter = createEntityAdapter({
  sortComparer: (a, b) => (a.sentTime > b.sentTime ? 1 : -1),
});

export const {
  selectById: selectMessageById,
  selectIds: selectMessageIds,
  selectEntities: selectMessageEntities,
  selectAll: selectAllMessages,
  selectTotal: selectTotalMessages,
} = messageAdapter.getSelectors((state) => state.messages);

export const selectMessagesByTargetId = (targetId) => (
  createSelector(
    selectAllMessages,
    (messages) => messages.filter((message) => (
      targetId && (
        message.targetId === targetId
      )
    )),
  )
);

export const MessagesSlice = createSlice({
  name: 'messages',
  initialState: messageAdapter.getInitialState(),
  reducers: {
    addMessage(state, action) {
      const message = action.payload;
      const normalizedData = normalize(message, messageEntity);
      messageAdapter.upsertMany(state, normalizedData.entities.messages);
    },
    resetMessages(state) {
      messageAdapter.removeAll(state);
    },
    setMessages(state, action) {
      const normalizedData = normalize(action.payload, [messageEntity]);
      messageAdapter.upsertMany(state, normalizedData.entities.messages);
    },
    removeMessage(state, action) {
      messageAdapter.removeOne(state, action.payload);
    },
  },
});

export const {
  addMessage, resetMessages, setMessages, removeMessage,
} = MessagesSlice.actions;

export default MessagesSlice.reducer;
